import React from 'react';
import cx from 'classnames';

export type PeriodButtonProps = {
  title: string;
  price: string;
  fullPrice?: number;
  discount?: number;
  isSelected: boolean;
  isLast?: boolean;
  onClick: () => void;
};

export const PeriodButton: React.FC<PeriodButtonProps> = React.memo((props) => {
  const { title, price, fullPrice, isSelected, onClick } = props;

  return (
    <button
      className={cx(
        'flex flex-col px-12 py-8 rounded-[8px] border-[.5px]',
        isSelected ? 'bg-primary-10 border-primary' : 'bg-white-3 border-white-3'
      )}
      onClick={onClick}
    >
      <div className="flex items-center justify-between w-full">
        <span className="text-r13 sm:text-r14 text-white">{title}</span>
        {/* {discount && (
          <div
            className={cx(
              'text-r12 px-[6px] rounded-[12px]',
              isLast
                ? 'text-black-1 bg-success'
                : isSelected
                  ? 'text-white bg-white-10'
                  : 'text-white bg-white-3'
            )}
          >
            -{discount}%
          </div>
        )} */}
      </div>
      <div className="flex items-center gap-4">
        <span className="text-r14 text-white">${price}</span>
        {fullPrice && <span className="text-r14 text-regular line-through">${fullPrice}</span>}
      </div>
    </button>
  );
});
